module.exports = __webpack_public_path__ + "img/selec-assess.90b03e46.svg";